
import Cropper, { ReactCropperElement } from "react-cropper";
import { createRef, useCallback, useEffect, useRef, useState } from "react";
import "cropperjs/dist/cropper.css";
import React from "react";


const CropperImage = (image: any) => {

  const cropperRef = createRef<ReactCropperElement>();
  const cropperInstance = useRef(null);
  const [cropData, setCropData] = useState({});
  const [zoomValue, setZoomValue] = useState(0);


  const onCrop = useCallback(
    (event: any) => {
      var width = event.detail.width;
      var height = event.detail.height;
      if (
        width < image?.minCroppedWidth ||
        height < image?.minCroppedHeight ||
        width > image?.maxCroppedWidth ||
        height > image?.maxCroppedHeight
      ) {
        if (cropperRef?.current !== null && cropperInstance?.current !== null) {
          setTimeout(() => {
            cropperRef?.current?.cropper.setData({
              width: Math.max(
                image?.minCroppedWidth,
                Math.min(image?.maxCroppedWidth, width)
              ),
              height: Math.max(
                image?.minCroppedHeight,
                Math.min(image?.maxCroppedHeight, height)
              )
            });
          });
        }
      }
    },
    [cropperInstance]
  );




  const getCropData = () => {
    if (typeof cropperRef.current?.cropper !== "undefined") {
      // setCropData(cropperRef?.current?.cropper?.getData(true));
      cropperRef.current?.cropper.getCroppedCanvas().toBlob((blob: any) => {
        const croppedImageURL = URL.createObjectURL(blob);
        const newfile = new File([blob], "c:files/myfile.webp");
        image?.getCropFunction?.(croppedImageURL, newfile)
      });
    }
  };

  const cancelCrop = () => {
    $("#profileImageData").val('')
    image.cancelCropData()
  }

  const handleZoomIn = useCallback((e: any) => {
    const newZoomValue = Number(e.target.value);
    setZoomValue(newZoomValue);
    if (cropperRef.current && cropperRef.current.cropper) {
      cropperRef.current.cropper.zoom(0.1);
    }
  }, [cropperRef]);

  const handleZoomOut = useCallback((e: any) => {
    const newZoomValue = Number(e.target.value);
    setZoomValue(newZoomValue);
    if (cropperRef.current && cropperRef.current.cropper) {
      cropperRef.current.cropper.zoom(-0.1);
    }
  }, [cropperRef]);

  const onCropStart = (() => {
    if (cropperRef.current && cropperRef.current.cropper) {
      cropperRef.current.cropper.zoom(-1.4);
    }
  });

  return (
    <>
      <div className="crop-overlay">


        <div style={{ width: "100%" }} className="custom-crop">
          <div className="custom-crop-inner">
            <Cropper
              ref={cropperRef}
              style={{}}
              cropBoxResizable={false}
              zoomOnWheel={false}
              zoomOnTouch={false}
              ready={onCropStart}
              zoomable={true}
              className="crop-inner"
              zoomTo={image?.zoomTo}
              initialAspectRatio={image?.initialAspectRatio}
              aspectRatio={image?.aspectRatio}
              preview=".img-preview"
              src={image?.image}
              viewMode={image?.viewMode}
              background={image?.background}
              responsive={image?.responsive}
              autoCropArea={image?.autoCropArea}
              checkOrientation={image?.checkOrientation}
              guides={image?.guides}
              dragMode="move"
              movable={true}
              cropBoxMovable={false}
            />

            {/* <Cropper
              ref={cropperRef}
              style={{}}
              cropBoxResizable={false}
              zoomOnWheel={false}
              zoomOnTouch={false}
              ready={onCropStart}
              zoomable={true}
              className="crop-inner"
              zoomTo={image?.zoomTo}
              initialAspectRatio={image?.initialAspectRatio}
              aspectRatio={image?.aspectRatio}
              preview=".img-preview"
              src={image?.image}
              viewMode={image?.viewMode}
              background={image?.background}
              responsive={image?.responsive}
              autoCropArea={image?.autoCropArea}
              checkOrientation={image?.checkOrientation}
              guides={image?.guides}
              dragMode="move"
            /> */}
            <div className="crop-range">
              <button className="crop-range-btn" onClick={handleZoomOut}><i className='bx bx-zoom-out'></i></button>
              <button className="crop-range-btn" onClick={handleZoomIn}><i className="bx bx-zoom-in" aria-hidden="true"></i></button>
            </div>
          </div>

          <div className="crop-ct">
            <div className="CropBTN">
              <button type='button' onClick={() => { getCropData() }} className='btn btn-info px-2 px-md-5'><i className='bx bx-crop me-2 align-middle fs-4'></i>Add</button>
              <button type='button' onClick={() => { cancelCrop() }} className='btn btn-danger px-2 px-md-5 ms-3'>Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </>

  )
}

export default CropperImage;